import { useNavigate } from 'react-router-dom'
import { Check } from 'lucide-react'
import dashboardHero from '../assets/landing/dashboard-hero.png'
import reminderCard from '../assets/landing/reminder-card.png'

export default function DashboardSection() {
  const navigate = useNavigate()

  return (
    <section className='relative w-full bg-white overflow-hidden text-left'>
      <div className='mx-auto max-w-[1920px] px-4 sm:px-6 lg:px-20 py-10 sm:py-14 lg:py-20'>
        <div className='flex flex-col xl:flex-row xl:items-start gap-6 lg:gap-10 xl:gap-[54px]'>
          {/* Dashboard image */}
          <div className='flex-1 min-w-0'>
            <div className='relative w-full rounded-[18px] lg:rounded-[27px] overflow-hidden shadow-[0_20px_50px_-10px_rgba(0,0,0,0.15)]'>
              <img
                src={dashboardHero}
                alt='BritFiler dashboard preview'
                className='block w-full h-auto object-cover'
              />
            </div>
          </div>

          {/* Right column: reminder card + 14 days card */}
          <div className='flex flex-col sm:flex-row xl:flex-col items-stretch gap-6 lg:gap-8 xl:gap-8 xl:w-[298px] flex-shrink-0'>
            {/* Reminder / Upcoming Filing card image */}
            <div className='flex-1 xl:flex-none xl:w-[293px]'>
              <img
                src={reminderCard}
                alt='Upcoming filing reminder card'
                className='block w-full h-auto rounded-[18px]'
                style={{
                  boxShadow: '0px 45px 45px 0px rgba(0,0,0,0.1)',
                }}
              />
            </div>

            {/* 14 Days Left filing card */}
            <UpcomingFilingCard onOpen={() => navigate('/sign-up')} />
          </div>
        </div>
      </div>
    </section>
  )
}

function UpcomingFilingCard({ onOpen }: { onOpen: () => void }) {
  return (
    <div
      className='flex-1 xl:flex-none xl:w-[298px] bg-white border border-[#D5D7DA] rounded-[18px] xl:rounded-[27px] px-4 py-5 flex flex-col gap-2.5 text-left'
      style={{
        fontFamily: '"DM Sans", sans-serif',
        filter: 'drop-shadow(0px 45px 22.5px rgba(0,0,0,0.1))',
      }}
    >
      <p className='text-[#F04438] text-xs leading-[18px] font-normal text-left'>
        14 Days Left
      </p>

      <div className='flex flex-col gap-5'>
        <div>
          <p className='text-[#181D27] text-sm font-bold leading-6 text-left'>
            ABC Ltd – Year Ending 31 Dec 2025
          </p>
          <p className='text-[#717680] text-sm leading-5 font-normal text-left'>
            Due Date:{' '}
            <span className='text-[#181D27]'>21-Sept-2025</span>
          </p>
        </div>

        <div className='flex flex-col gap-0.5'>
          <FilingChecklistRow label='Corporation Tax (CT600)' />
          <FilingChecklistRow label='Accounts' />
        </div>

        <button
          onClick={onOpen}
          className='w-full h-10 bg-[#FEF3F2] border border-[#F04438] rounded-lg text-[#D92D20] text-sm font-semibold leading-5 hover:bg-[#FEE4E2] transition-colors cursor-pointer'
          style={{
            boxShadow: '0px 1px 2px 0px rgba(10,13,18,0.05)',
          }}
        >
          Open
        </button>
      </div>
    </div>
  )
}

function FilingChecklistRow({ label }: { label: string }) {
  return (
    <div className='flex items-center justify-between gap-2.5'>
      <span className='text-[#181D27] text-[13px] leading-7 font-normal text-left'>
        {label}
      </span>
      <span className='flex-shrink-0 flex items-center justify-center w-6 h-6 rounded-full bg-[#12B76A]'>
        <Check className='w-3.5 h-3.5 text-white' strokeWidth={3} />
      </span>
    </div>
  )
}
